// extracted by mini-css-extract-plugin
export default {"title":"ArrowToggle_title__o+EJz","count":"ArrowToggle_count__oda3G","unit":"ArrowToggle_unit__f2k4D"};